// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme--light.v-divider {
  border-color: rgba(0,0,0,0.12);
}
.theme--dark.v-divider {
  border-color: rgba(255,255,255,0.12);
}
.v-divider {
  display: block;
  flex: 1 1 0px;
  max-width: 100%;
  height: 0px;
  max-height: 0px;
  border: solid;
  border-width: thin 0 0 0;
  transition: inherit;
}
.v-divider--inset:not(.v-divider--vertical) {
  margin-left: 72px;
  max-width: calc(100% - 72px);
}
.v-divider--vertical {
  align-self: stretch;
  border: solid;
  border-width: 0 thin 0 0;
  display: inline-flex;
  height: inherit;
  min-height: 100%;
  max-height: 100%;
  max-width: 0px;
  width: 0px;
  vertical-align: text-bottom;
}
.v-divider--vertical.v-divider--inset {
  margin-top: 8px;
  min-height: 0;
  max-height: calc(100% - 16px);
}
`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/src/stylus/theme.styl","webpack://./node_modules/vuetify/src/stylus/components/_dividers.styl"],"names":[],"mappings":"AAOE;ECHA,8BAAwB;AAF1B;ADSE;ECPA,oCAAwB;AAC1B;AAGA;EACE,cAAS;EACT,aAAM;EACN,eAAW;EACX,WAAQ;EACR,eAAY;EACZ,aAAQ;EACR,wBAAc;EACd,mBAAY;AADd;AAGE;EACE,iBAAa;EACb,4BAAW;AADf;AAGE;EACE,mBAAY;EACZ,aAAQ;EACR,wBAAc;EACd,oBAAS;EACT,eAAQ;EACR,gBAAY;EACZ,gBAAY;EACZ,cAAW;EACX,UAAO;EACP,2BAAgB;AADpB;AAGI;EACE,eAAY;EACZ,aAAY;EACZ,6BAAY;AADlB","sourcesContent":["@import './settings/_theme.styl'\n\ntheme($component, $name)\n  light($component, $name)\n  dark($component, $name)\n\nlight($component, $name)\n  .theme--light.{$name}\n    $component($material-light)\n\ndark($component, $name)\n  .theme--dark.{$name}\n    $component($material-dark)\n","@import '../bootstrap'\n@import '../theme'\n\nv-divider($material)\n  border-color: $material.dividers\n\ntheme(v-divider, \"v-divider\")\n\n.v-divider\n  display: block\n  flex: 1 1 0px\n  max-width: 100%\n  height: 0px\n  max-height: 0px\n  border: solid\n  border-width: thin 0 0 0\n  transition: inherit\n\n  &--inset:not(.v-divider--vertical)\n    margin-left: 72px\n    max-width: calc(100% - 72px)\n\n  &--vertical\n    align-self: stretch\n    border: solid\n    border-width: 0 thin 0 0\n    display: inline-flex\n    height: inherit\n    min-height: 100%\n    max-height: 100%\n    max-width: 0px\n    width: 0px\n    vertical-align: text-bottom\n\n    &.v-divider--inset\n      margin-top: 8px\n      min-height: 0\n      max-height: calc(100% - 16px)\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
